import { RouteRecordRaw, RouterScrollBehavior, createRouter, createWebHistory } from 'vue-router'

import { RouterRegistry } from '../util/routerRegistry'
import { agencyRoutes } from './agency'
import { getCurrentInstance } from 'vue'
import { pmd } from './pmd'
import { v2 } from './v2'

// Note: patch for duplicated routes error from vue-router
const originalPush = createRouter.prototype.push
createRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


const routes: RouteRecordRaw[] = [
  ...pmd,
  ...v2,
  ...agencyRoutes,
]

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  }
  return { top: 0, left: 0 }
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior
})

// Register router in the registry for use outside of Vue components
RouterRegistry.setRouter(router)

function useRoute() {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy?.$route
}

function useRouter() {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy?.$router
}

export { useRoute, useRouter }
export default router
